import { createRouter, createWebHistory } from 'vue-router'
// import { Top } from "module";
import Top from '../components/Top.vue'
// import HelloWorld from '../components/HelloWorld.vue'
// import ShindanPage from '../components/Shindan.vue'//通常問い合わせ
import Thanks from '../components/Thanks.vue'
import NextJourney from '@/components/NextJourney.vue'
import TOS from '@/components/TOS.vue'
import HeaderTop from '@/components/HeaderTop.vue'
import CybozuDays2024 from '@/components/CybozuDays2024.vue'//CybozuDays2024特別バージョン


const routes = [
  // { path: '/', name: 'top', component: Top },//ヘッダーなし
  { path: '/', name: 'top', component: HeaderTop },
  { path: '/test', name: 'Home', component: Top },//テストページ
  // { path: '/shindan', name: 'shindan', component: ShindanPage },//通常時
  { path: '/shindan', name: 'shindan', component: CybozuDays2024 },
  { path: '/thanks', name: 'Thanks', component: Thanks },
  { path: '/tos', name: 'tos', component: TOS },
  { path: '/nextjourney', name: 'nextjourney', component: NextJourney },
  // { path: '/tos', name: 'tos', component: TosPage },
  // {
  //   //01Home ホームページ
  //   path: "/",
  //   name: "Home",
  //   component: () => import("../components/Top.vue"),
  // },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})
export default router;